import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableGraphicManagerVODHistoric from '../formGroupLiveApps/tableGraphicManagerVODHistoric';
import tableGraphicManagerLIVEHistoric from '../formGroupLiveApps/tableGraphicManagerLIVEHistoric';
export default {
  title: 'Graphic Historic',
  attributeName: 'graphicsHistoric',
  
  fields: [
    {
      attributeName: 'graphicManagerHistoricTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableGraphicManagerLIVEHistoric,
      visibleWhen:{"field":"type","value":"LIVE"},

    },
    {
      attributeName: 'graphicManagerHistoricTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableGraphicManagerVODHistoric,
      visibleWhen:{"field":"type","value":"VOD"},

    },
  ],
};